import React, { useEffect, useState } from 'react';
import MenuList from './MenuList';
import {
	stuffedPizza,
	thinCrust,
	extraThinCrust,
	starters,
	salads,
	sandwiches,
	pastas,
	desserts,
} from '../../../data/category';

export default function MenuPage() {
	const [selected, setSelected] = useState('starte');
	const [data, setData] = useState([]);
	const categories = [
		{
			id: 'starters',
			title: 'Starters',
		},
		{
			id: 'salads',
			title: 'Salads',
		},
		{
			id: 'pastas',
			title: 'Pastas',
		},
		{
			id: 'sandwiches',
			title: 'Sandwiches',
		},
		{
			id: 'stuffedPizza',
			title: 'Stuffed',
		},
		{
			id: 'thinCrust',
			title: 'Thin Crust',
		},
		{
			id: 'extraThinCrust',
			title: 'Extra Thin',
		},

		{
			id: 'desserts',
			title: 'Desserts',
		},
	];
	useEffect(() => {
		switch (selected) {
			case 'starters':
				setData(starters);
				break;
			case 'salads':
				setData(salads);
				break;
			case 'stuffedPizza':
				setData(stuffedPizza);
				break;
			case 'thinCrust':
				setData(thinCrust);
				break;
			case 'extraThinCrust':
				setData(extraThinCrust);
				break;
			case 'sandwiches':
				setData(sandwiches);
				break;
			case 'pastas':
				setData(pastas);
				break;
			case 'desserts':
				setData(desserts);
				break;
			default:
				setData(stuffedPizza);
		}
	}, [selected]);
	return (
		<div className='menupage'>
			<h1>Menu</h1>
			<ul className='category-selection'>
				{categories.map((item) => (
					<MenuList
						title={item.title}
						active={selected === item.id}
						setSelected={setSelected}
						id={item.id}
						key={item.id}
					/>
				))}
			</ul>
			<div className='container'>
				{data.map((d, i) => (
					<div className='item' key={i}>
						<div className='top'>
							<h3>{d.title}</h3>
							<h3>{d.price}</h3>
						</div>
						<div className='description'>
							{/* <p>{d.description}</p> */}
							<details>
								<summary>check ingredients</summary>
								{d.description}
							</details>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
